import SettingsDocumentTemplatesList from './list'


if (document.body.getAttribute("data-current-path") === "settings/document_templates") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new SettingsDocumentTemplatesList();
    }
}